export default ({ request }) => ({
  mrpOutsourcingStockInListApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/stockIn/list',
      method: 'post',
      data,
    })
  },
  mrpOutsourcingStockInDetailApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/stockIn/detail',
      method: 'post',
      data,
    })
  },
  mrpOutsourcingStockInSaveApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/stockIn/save',
      method: 'post',
      data,
    })
  },
  mrpOutsourcingStockInDelApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/stockIn/del',
      method: 'post',
      data,
    })
  },
  mrpOutsourcingStockInSubmitApi(data = {}) {
    return request({
      url: '/factory/mrp/outsourcing/stockIn/submit',
      method: 'post',
      data,
    })
  },
})
